import React, { useState, useRef, useEffect } from "react";
import { API_URL, LOCATION_ID } from "..";

const AddExpenseLayer = () => {

  const locationId = LOCATION_ID;
  const formRef = useRef(null);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(`${API_URL}/api/expense-category`);
        const data = await res.json();
        setCategories(data);
      } catch (error) {
        console.log("Error loading categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const [message, setMessage] = useState({ status: false, reason: "", desc: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitExpense = async (e) => {
    e.preventDefault();
    setMessage({ status: false, reason: "", desc: "" });

    const form = formRef.current;

    const payload = {
      expense_title: form.expense_title.value,
      expense_amount: form.expense_amount.value,
      expense_date: form.expense_date.value,
      categoryId: form.category.value,
      notes: form.notes.value,
      locationId: LOCATION_ID,
      reference_type: null,
      reference_id: null,
    };

    if (!payload.expense_title)
      return setMessage({ status: true, reason: "error", desc: "Expense title is required" });

    if (!payload.expense_amount)
      return setMessage({ status: true, reason: "error", desc: "Amount is required" });

    if (!payload.expense_date)
      return setMessage({ status: true, reason: "error", desc: "Date is required" });

    if (!payload.categoryId)
      return setMessage({ status: true, reason: "error", desc: "Category is required" });

    setIsSubmitting(true);

    try {
      const res = await fetch(`${API_URL}/api/expenses`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage({
          status: true,
          reason: "success",
          desc: "Expense added successfully",
        });

        form.reset();
      } else {
        throw new Error(data.message || "Failed to create expense");
      }
    } catch (err) {
      setMessage({ status: true, reason: "error", desc: err.message });
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-body p-24">
        <div className="row justify-content-center">
          <div className="col-xxl-8 col-xl-10 col-lg-10">
            <div className="card border radius-12">
              <div className="card-body">

                {/* Messages */}
                {message.status && (
                  <div
                    className={`alert alert-${message.reason === "error" ? "danger" : "success"} alert-dismissible fade show mb-20`}
                    role="alert"
                  >
                    {message.desc}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setMessage({ ...message, status: false })}
                      aria-label="Close"
                    ></button>
                  </div>
                )}

                {/* <h4 className="mb-4 text-center fw-bold">Add Expense</h4> */}

                <form ref={formRef} onSubmit={submitExpense}>
                  
                  {/* Expense Title */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Expense Title <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="expense_title"
                      className="form-control radius-8"
                      placeholder="e.g. Fuel Cost / Staff Lunch / Electricity Bill"
                    />
                  </div>

                  {/* Amount */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Amount <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      name="expense_amount"
                      className="form-control radius-8"
                      placeholder="Enter amount"
                    />
                  </div>

                  {/* Date */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Expense Date <span className="text-danger">*</span>
                    </label>
                    <input type="date" name="expense_date" className="form-control radius-8" />
                  </div>

                 <select name="category" className="form-control radius-8">
  <option value="">Select Category</option>
  {categories.map(cat => (
    <option key={cat.id} value={cat.id}>
      {cat.title}
    </option>
  ))}
</select>


                  {/* Notes */}
                  <div className="mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Notes
                    </label>
                    <textarea
                      name="notes"
                      className="form-control radius-8"
                      rows="3"
                      placeholder="Optional notes..."
                    ></textarea>
                  </div>

                  {/* Submit */}
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary px-56 py-12 radius-8"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Expense"}
                    </button>
                  </div>

                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddExpenseLayer;
